import { TokenMessageEvent } from './types';

export const isTokenMessage = (message: object): message is TokenMessageEvent =>
  (message as any)?.messageType === 'token';
